import { render } from "./InputDashboard.vue?vue&type=template&id=0b16b07a&scoped=true"
import script from "./InputDashboard.vue?vue&type=script&lang=js"
export * from "./InputDashboard.vue?vue&type=script&lang=js"

import "./InputDashboard.vue?vue&type=style&index=0&id=0b16b07a&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b16b07a"]])

export default __exports__